import '../../../App.css'
import './EventOpenBetting.css';
import { useState, useEffect } from 'react';
import { Input, Table, Select, Pagination } from 'antd';

import axios from 'axios';
import Appconfig from '../../../config/config'
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { TfiPencilAlt } from "react-icons/tfi";
import { useNavigate, useParams } from "react-router-dom";


function EventOpenBetting() {
    const navigate = useNavigate();
    const params = useParams();
    const { event_type } = params

    const userInfo = JSON.parse(localStorage.getItem('userdata'))
    const [openNews, setOpenNews] = useState(false)
    const [button, setButton] = useState(false)


    const [eventTypes, setEventTypes] = useState([])
    const [formData, setFormData] = useState({
        domain_name: "",
        site_code: "",
    });
    const [id, setId] = useState('')

    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState(data);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    let locale = {
        emptyText: 'No data!',
    };

    const handleSearch = (value, dataIndex) => {

        if (!value) {
            setFilteredData(data);
            return;
        }

        const filtered = data.filter(item => {
            return Array.isArray(dataIndex)
                ? dataIndex.some(key => item[key]?.toString().toLowerCase().includes(value.toLowerCase()))
                : item[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase());
        });

        // const filtered = data.length ? data.filter(item => item[dataIndex].toString().toLowerCase().includes(value.toLowerCase())) : [];
        setFilteredData(filtered);
        setCurrent(1); // Reset to the first page after a search
    };

    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1); // Reset to the first page after changing page size
    };

    const handleFirst = () => setCurrent(1);
    const handleLast = () => setCurrent(Math.ceil(filteredData?.length / pageSize));

    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedData = filteredData.slice(
        startIndex,
        endIndex
    );


    const handleSetFormData = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
    };


    function getOpenBetsEventData() {
        var data = JSON.stringify({
            user_id: userInfo?._id,
            event_type: event_type
        });

        var config = {
            method: "post",
            url: `${Appconfig.apiUrl}betting/getOpenBetsEventData`,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if (response.data.result) {
                    setFilteredData(response.data.resultData);
                    setData(response.data.resultData)
                }
                else {
                    console.log(response)
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const navigateToDetails = (event_id) => {
        navigate(`/betting/openBetsByEvent/${event_id}`);
    };

    const formatDateTime = (dateValue) => {
        if (!dateValue) {
            return '-';
        }

        const date = new Date(dateValue);

        if (Number.isNaN(date.getTime())) {
            return dateValue;
        }

        const pad = (value) =>
            String(value).padStart(2, '0');

        const day = pad(date.getDate());
        const month = pad(
            date.getMonth() + 1
        );
        const year = date.getFullYear();

        const hours = pad(date.getHours());
        const minutes = pad(
            date.getMinutes()
        );

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    const columns = [
        {
            title: 'S.N.',
            key: 'serial_number',
            width: 100,
            render: (_, record, index) => (
                <span className="event-betting-serial">
                    {startIndex + index + 1}
                </span>
            ),
        },
        {
            title: 'Match Name',
            key: 'match_name',
            render: (_, record) => (
                <button
                    type="button"
                    className="event-betting-match-link"
                    onClick={() =>
                        navigateToDetails(
                            record.match_id
                        )
                    }
                >
                    {record.event_name}
                </button>
            ),
        },
        {
            title: 'Date & Time',
            key: 'created_date',
            width: 210,
            render: (_, record) => (
                <span className="event-betting-date">
                    {formatDateTime(
                        record.createdAt
                    )}
                </span>
            ),
        },
    ];

    useEffect(() => {
        getOpenBetsEventData();
    }, [])

    return (
        <>
            <NotificationContainer />

            <main className="event-betting-page">
                <section className="event-betting-card">
                    <div className="event-betting-heading">
                        <div className="event-betting-heading-content">
                            <span className="event-betting-heading-icon">
                                ⚙
                            </span>

                            <div>
                                <h1>Open Betting Events</h1>

                                <p>
                                    Select a match to view
                                    its open betting details
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="event-betting-summary">
                        <div>
                            <span>Total Events</span>

                            <strong>
                                {data.length}
                            </strong>
                        </div>

                        <div>
                            <span>Search Results</span>

                            <strong>
                                {filteredData.length}
                            </strong>
                        </div>
                    </div>

                    <div className="event-betting-toolbar">
                        <label className="event-betting-page-size">
                            <span>Show</span>

                            <Select
                                value={pageSize}
                                onChange={
                                    handlePageSizeChange
                                }
                                options={[
                                    {
                                        value: 10,
                                        label: '10',
                                    },
                                    {
                                        value: 25,
                                        label: '25',
                                    },
                                    {
                                        value: 50,
                                        label: '50',
                                    },
                                    {
                                        value: 100,
                                        label: '100',
                                    },
                                ]}
                            />

                            <span>entries</span>
                        </label>

                        <label className="event-betting-search">
                            <span>Search</span>

                            <Input
                                allowClear
                                placeholder="Search match name"
                                onChange={(event) =>
                                    handleSearch(
                                        event.target.value,
                                        ['event_name']
                                    )
                                }
                            />
                        </label>
                    </div>

                    <div className="event-betting-table-wrapper">
                        <Table
                            rowKey={(record) =>
                                record?._id ||
                                record?.match_id
                            }
                            locale={locale}
                            columns={columns}
                            className="event-betting-table"
                            dataSource={paginatedData}
                            pagination={false}
                            scroll={{
                                x: 700,
                            }}
                        />
                    </div>

                    <div className="event-betting-pagination">
                        <div className="event-betting-showing">
                            Showing{' '}
                            {filteredData.length
                                ? startIndex + 1
                                : 0}{' '}
                            to{' '}
                            {Math.min(
                                endIndex,
                                filteredData.length
                            )}{' '}
                            of {filteredData.length}{' '}
                            entries
                        </div>

                        <div className="event-betting-pagination-controls">
                            <button
                                type="button"
                                onClick={handleFirst}
                                disabled={current === 1}
                            >
                                First
                            </button>

                            <Pagination
                                current={current}
                                pageSize={pageSize}
                                total={
                                    filteredData.length
                                }
                                onChange={(page) =>
                                    setCurrent(page)
                                }
                                itemRender={(
                                    page,
                                    type,
                                    originalElement
                                ) => {
                                    if (
                                        type === 'prev'
                                    ) {
                                        return (
                                            <span>
                                                Previous
                                            </span>
                                        );
                                    }

                                    if (
                                        type === 'page'
                                    ) {
                                        return null;
                                    }

                                    if (
                                        type === 'next'
                                    ) {
                                        return (
                                            <span>
                                                Next
                                            </span>
                                        );
                                    }

                                    return originalElement;
                                }}
                                showSizeChanger={false}
                            />

                            <button
                                type="button"
                                onClick={handleLast}
                                disabled={
                                    current >=
                                    Math.max(
                                        1,
                                        Math.ceil(
                                            filteredData.length /
                                            pageSize
                                        )
                                    )
                                }
                            >
                                Last
                            </button>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}


export default EventOpenBetting;
